var tbBase = /** @class */ (function () {
    function tbBase() {
    }
    return tbBase;
}());
export { tbBase };
